import { render, staticRenderFns } from "./AlertTransaction.vue?vue&type=template&id=b2c13d4e"
import script from "./AlertTransaction.vue?vue&type=script&lang=js"
export * from "./AlertTransaction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports